import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import useSignIn from './useSignIn';
import Text from '../Text';
import Checkbox from '../CheckBox/Checkbox.jsx';
import { Button } from '../FormStyles';
import TextInput from '../FormStyles/TextInput.jsx';
import Modal from '../Modal/Modal.jsx';
import ResetPassword from '../ResetPassword/ResetPassword.jsx';

const CheckboxWrapper = styled.div`
  label {
    font-size: 12px;
    margin-left: 2px;
  }
`;

const FormWrapper = styled.div`
  padding: 16px;
  width: 100%;

  ${themeGet('mediaQueries.forMediumUp')} {
    padding: 24px;
    width: 394px;
  }
`;

const XIcon = styled.i`
  cursor: pointer;
`;

XIcon.defaultProps = {
  className: 'fa-light fa-circle-x',
};

const Title = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const TermsWrapper = styled.div`
  text-align: left;
  margin: 8px 0 16px;
`;

const ButtonGroup = styled.div`
  margin-top: 16px;
  text-align: right;
`;

const CancelButton = styled(Button)`
  margin: 0;
`;

const SignInButton = styled(Button)`
  margin: 0 0 0 8px;
`;

const resetPasswordModal = setOpenSignInModal => {
  setOpenSignInModal(false);
  Modal({
    component: <ResetPassword />,
    width: '394px',
    padding: '0px',
  });
};

const SignIn = ({ setOpenSignInModal, setOpenCreateModal }) => {
  const { t } = useTranslation('signIn');

  const {
    values,
    handleSubmit,
    handleChange,
    inputError,
    disabledSubmit,
    handleBlur,
  } = useSignIn();

  return (
    <FormWrapper>
      <Title>
        <Text variant="h5">{t('signIn')}</Text>
        <XIcon alt="exit" onClick={() => setOpenSignInModal(false)} />
      </Title>
      <Text variant="small2" color="red" as="span" style={{ float: 'right' }}>
        {values.errorField}
      </Text>
      <TextInput
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={inputError('email')}
        name="email"
        m="0 0 16px"
        label={t('email')}
        placeholder={t('enterEmail')}
      />
      <Text
        variant="small4"
        color="primary.100"
        as="a"
        alt={t('resetPassword')}
        onClick={() => resetPasswordModal(setOpenSignInModal)}
        style={{ position: 'absolute', zIndex: 2, right: '24px' }}
      >
        {t('resetPasswordLinkText')}
      </Text>
      <TextInput
        value={values.password}
        onChange={handleChange}
        onBlur={handleBlur}
        error={inputError('password')}
        type="password"
        name="password"
        m="0 0 16px"
        label={t('password')}
        placeholder={t('enterPassword')}
      />
      <TermsWrapper>
        <Text variant="small4" color="black.80">
          {t('noAccount')}
        </Text>
        <Text
          variant="small4"
          color="primary.100"
          as="a"
          alt={t('createAccount')}
          onClick={() => {
            setOpenSignInModal(false);
            setOpenCreateModal(true);
          }}
        >
          &nbsp;{t('createAccount')}
        </Text>
      </TermsWrapper>
      <CheckboxWrapper>
        <Checkbox
          name="rememberMe"
          onChangeHandler={handleChange}
          checked={values.rememberMe}
          value={values.rememberMe}
          label={t('rememberMe')}
        />
      </CheckboxWrapper>
      <ButtonGroup>
        <CancelButton
          variant="tertiary"
          onClick={() => setOpenSignInModal(false)}
        >
          {t('cancel')}
        </CancelButton>
        <SignInButton
          variant="containedBlue"
          onClick={handleSubmit}
          disabled={disabledSubmit}
        >
          {t('signIn')}
        </SignInButton>
      </ButtonGroup>
    </FormWrapper>
  );
};

export default SignIn;
